import { isDate } from './isDate';

/**
 * @typedef {Object} WistiaDateTimeObject
 * @property {number} minutes - number of minutes
 * @property {number} hours - number of hours
 * @property {number} dayOfMonth - day of the month
 * @property {number} year - year
 * @property {number} month - month
 */
/**
 * @param {Date | null | undefined} date - a Date object
 * @returns {WistiaDateTimeObject | null} - replaceMe
 */
export const dateToDateTime = (date: Date | null | undefined): WistiaDateTimeObject | null => {
  if (!isDate(date)) {
    return null;
  }

  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    dayOfMonth: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
  };
};
